/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { MutationTree } from "vuex";
import { IRootState } from "./state";
import { ISnackbarData } from "@/components/md/MdSnackbar";
import { IVariablePickerPayload } from "@/store/types";

export enum Mutations {
  SET_INITIALIZED = "SET_INITIALIZED",
  SET = "SET",
  SIDENAV_RAIL = "SIDENAV_RAIL",
  SET_SNACKBAR = "SET_SNACKBAR",
  REMOVE_SNACKBAR = "REMOVE_SNACKBAR",
  OPEN_VARIABLE_PICKER = "OPEN_VARIABLE_PICKER",
  CLOSE_VARIABLE_PICKER = "CLOSE_VARIABLE_PICKER",
  SET_LOADER = "SET_LOADER",
}

export interface IMutations<S = IRootState> {
  [Mutations.SET_INITIALIZED](state: S, payload: boolean): void;
  [Mutations.SET](state: S, payload: boolean): void;
  [Mutations.SIDENAV_RAIL](state: S, payload: boolean): void;
  [Mutations.SET_SNACKBAR](state: S, payload: ISnackbarData): void;
  [Mutations.REMOVE_SNACKBAR](state: S): void;
  [Mutations.OPEN_VARIABLE_PICKER](
    state: S,
    payload: IVariablePickerPayload
  ): void;
  [Mutations.CLOSE_VARIABLE_PICKER](state: S): void;
  [Mutations.SET_LOADER](state: S, payload: boolean): void;
}

export const mutations: MutationTree<IRootState> & IMutations = {
  [Mutations.SET_INITIALIZED]: (state: IRootState, payload: boolean) => {
    state.initialized = payload;
  },
  [Mutations.SET]: (state: IRootState, isRoot: boolean) => {
    state.root = isRoot;
  },
  [Mutations.SIDENAV_RAIL]: (state: IRootState, payload: boolean) => {
    state.sidenavRail = payload;
  },
  [Mutations.SET_SNACKBAR]: (state: IRootState, payload: ISnackbarData) => {
    state.snackbar = payload;
  },
  [Mutations.REMOVE_SNACKBAR]: (state: IRootState) => {
    state.snackbar = null;
  },
  [Mutations.OPEN_VARIABLE_PICKER]: (
    state: IRootState,
    payload: IVariablePickerPayload
  ) => {
    state.variablePicker.open = true;
    state.variablePicker.anchor = payload.anchor;
    state.variablePicker.target = payload.target;
    state.variablePicker.variable = payload.variable || null;
  },
  [Mutations.CLOSE_VARIABLE_PICKER]: (state: IRootState) => {
    state.variablePicker.open = false;
    state.variablePicker.anchor = null;
    state.variablePicker.target = null;
    state.variablePicker.variable = null;
  },
  [Mutations.SET_LOADER]: (state: IRootState, payload: boolean) => {
    state.showLoader = payload;
  },
};
